// John Eldhose 20190213
import { RestfulPost } from './Restful';

export async function lmdprint(data) {
  const rpt = await RestfulPost('lmdprint', data, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return rpt;
}



// WEBPACK FOOTER //
// ./src/Api/lmdprint.js